import {Modal, ModalContent, ModalFooter, ModalTitle} from '@hm/fundamental'

import {ConfirmDialogActions, type ConfirmDialogActionsProps} from './ConfirmDialogActions'
import {ConfirmDialogContent, type ConfirmDialogContentProps} from './ConfirmDialogContent'

interface ConfirmDialogProps extends ConfirmDialogActionsProps, ConfirmDialogContentProps {
  title: string
  testId?: string
  closeModal: () => void
}

export const ConfirmDialog = ({
  title,
  description,
  additionalContent,
  mainAction,
  onCancel,
  testId = 'confirm_dialog',
  showCancelButton,
  closeModal
}: ConfirmDialogProps) => (
  <Modal open={true} onClose={closeModal} isExitEnabled={false} data-cy={testId}>
    <ModalTitle>{title}</ModalTitle>
    <ModalContent>
      <ConfirmDialogContent description={description} additionalContent={additionalContent} />
    </ModalContent>
    <ModalFooter>
      <ConfirmDialogActions
        mainAction={{
          ...mainAction,
          onAction: () => {
            void mainAction.onAction?.()
            closeModal()
          }
        }}
        onCancel={() => {
          void onCancel?.()
          closeModal()
        }}
        showCancelButton={showCancelButton}
      />
    </ModalFooter>
  </Modal>
)
